import { createContext } from 'react';

export interface IToastContext {
  toastState: {
    show: boolean;
    content: string;
    duration?: number;
    isError?: boolean;
  };
  setToastState: Function;
  dispatchToast: Function;
}

export const ToastContext = createContext<IToastContext>({
  toastState: {
    show: false,
    content: '',
    duration: 3000,
    isError: false,
  },
  setToastState: () => {},
  dispatchToast: () => {}
});
